'use strict';

class Slider {

    constructor() {

        this.contentSlider();
        this.themeProductSlider();

    }

    contentSlider() {

        let contentSlider = document.querySelectorAll('.ce-content-slider');

        if (contentSlider.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of contentSlider) {

                new Swiper(slider.querySelector('.swiper-container'), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 16,
                    slidesPerView: 1.4,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    a11y: {
                        prevSlideMessage: rk_globals.translations.previous_slide,
                        nextSlideMessage: rk_globals.translations.next_slide,
                        paginationBulletMessage: rk_globals.translations.go_to_slide + ' {{index}}'
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 1.3
                        }
                    },

                });

            }

        }

    }

    themeProductSlider() {

        let themeProductSlider = document.querySelectorAll('.ce-theme-slider, .ce-product-slider');

        if (themeProductSlider.length > 0) {

            //  Require module only if there is a Media slider requested
            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of themeProductSlider) {

                let themeProductSwiper = new Swiper(slider.querySelector('.swiper-container'), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 16,
                    slidesPerView: 4.2,
                    watchOverflow: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false
                    },
                    navigation: {
                        nextEl: slider.querySelector('.next-slide'),
                        prevEl: slider.querySelector('.prev-slide')
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    a11y: {
                        prevSlideMessage: rk_globals.translations.previous_slide,
                        nextSlideMessage: rk_globals.translations.next_slide,
                        paginationBulletMessage: rk_globals.translations.go_to_slide + ' {{index}}'
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 1.3
                        }
                    },
                    on: {
                        slideChange: function () {
                            let paginationList = themeProductSwiper.pagination.el;
                            let bullet = paginationList.querySelectorAll('.swiper-pagination-bullet');
                            let activeBullet = paginationList.querySelector('.swiper-pagination-bullet-active');

                            let i;
                            for (i = 0; i < bullet.length; i++) {
                                bullet[i].innerHTML = "";
                            }

                            activeBullet.innerHTML = '<span class="show-for-sr">Actieve slide</span>';
                        }
                    }
                });

            }

        }

    }

}

module.exports = Slider;
